/**
 * COPIED FROM EndUserApp src/lib/session-store/SessionStore.js
 */

// For mocking purposes
function getSessionStorage(): Storage {
  return window.sessionStorage; // Global
}

class SessionStore {
  KEY_PREFIX: string;

  SERVICE_VERSION: string;

  memoryStore: Record<string, unknown>;

  sessionStorage: Storage | null;

  /**
   * First we test to see browser can use session storage.
   * See http://stackoverflow.com/questions/14555347
   * Note that this will return false if we are actually hitting the maximum sessionStorage
   * size (5MB / 2.5M chars)
   */
  constructor() {
    this.KEY_PREFIX = 'sessionStore';
    // Version is used to avoid backward incompatability issues
    // i.e. if a service that depends on this updates the value it
    // expects for a key
    this.SERVICE_VERSION = '1';
    this.memoryStore = {};
    this.sessionStorage = null;

    try {
      const sessionStorage = getSessionStorage();

      sessionStorage.setItem('key', 'value');
      sessionStorage.removeItem('key');

      // If everything passes, then set member variable sessionStorage
      this.sessionStorage = sessionStorage;
    } catch (e) {
      // no-op
    }
  }

  /**
   * Builds a key for the session store
   *
   * @param  {string} key
   *
   * @returns {string}
   */

  buildKey(key: string) {
    return `${this.KEY_PREFIX}/${this.SERVICE_VERSION}/${key}`;
  }

  /**
   * Set an item
   *
   * @param {string} key
   * @param {*} value
   *
   * @returns {void}
   */
  setItem(key: string, value: unknown) {
    if (this.sessionStorage) {
      try {
        this.sessionStorage.setItem(this.buildKey(key), JSON.stringify(value));
      } catch (e) {
        /* no-op */
      }
    } else {
      this.memoryStore[key] = value;
    }
  }

  /**
   * Get an item
   *
   * @param  {string} key
   *
   * @returns {*}
   */
  getItem(key: string) {
    if (this.sessionStorage) {
      try {
        const item = this.sessionStorage.getItem(this.buildKey(key));
        return item ? JSON.parse(item) : null;
      } catch (e) {
        return null;
      }
    } else {
      return this.memoryStore[key];
    }
  }

  /**
   * Remove an item
   *
   * @param  {string} key
   *
   * @returns {void}
   */
  removeItem(key: string) {
    if (this.sessionStorage) {
      try {
        this.sessionStorage.removeItem(this.buildKey(key));
      } catch (e) {
        /* no-op */
      }
    } else if (this.memoryStore[key]) {
      delete this.memoryStore[key];
    }
  }
}

export default SessionStore;
